import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';

// Só visual: o nome que a pessoa deu à origem escolhe ícone e cor.
// Nome sem correspondência cai no ícone neutro.
const VISUALS = [
  { match: ['instagram', 'insta'], Icon: InstagramIcon, tone: 'instagram' },
  { match: ['facebook', 'meta'], Icon: FacebookIcon, tone: 'facebook' },
  { match: ['google'], Icon: GoogleIcon, tone: 'google' },
  { match: ['whatsapp', 'zap'], Icon: WhatsAppIcon, tone: 'whatsapp' },
  { match: ['youtube'], Icon: YouTubeIcon, tone: 'youtube' },
  { match: ['linkedin'], Icon: LinkedInIcon, tone: 'linkedin' },
  { match: ['indica', 'boca a boca', 'amigo'], Icon: PeopleAltOutlinedIcon, tone: 'referral' },
  { match: ['site', 'web', 'blog', 'landing'], Icon: LanguageOutlinedIcon, tone: 'web' },
  { match: ['e-mail', 'email', 'newsletter'], Icon: MailOutlineRoundedIcon, tone: 'web' },
  { match: ['telefone', 'ligação', 'ligacao'], Icon: PhoneOutlinedIcon, tone: 'referral' },
  { match: ['evento', 'feira', 'panfleto', 'placa', 'fachada'], Icon: StorefrontOutlinedIcon, tone: 'offline' },
];

const FALLBACK = { Icon: HubOutlinedIcon, tone: 'neutral' };

export function sourceVisual(name) {
  const text = String(name || '').toLowerCase();
  return VISUALS.find((v) => v.match.some((word) => text.includes(word))) || FALLBACK;
}
